import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatHero = createCustomElementWrapper('kat-hero', 'KatHero', {
    'extendedInfoLabel': 'extended-info-label',
}, {});
